import { Route } from '@angular/router';

import { adminGuard } from '../auth/guards/admin.guard';
import { MainPage } from './main.page';

export const mainRoutes: Route[] = [
  {
    path: '',
    component: MainPage,
    children: [
      {
        path: '',
        redirectTo: 'exercises',
        pathMatch: 'full',
      },
      {
        path: 'users',
        loadChildren: () =>
          import('../../feature/users/users.routes').then(
            (m) => m.usersRoutes,
          ),
        canActivate: [adminGuard],
      },
      {
        path: 'exercises',
        loadChildren: () =>
          import('../../feature/exercises/exercises.routes').then(
            (m) => m.exercisesRoutes,
          ),
      },
      {
        path: 'files',
        loadChildren: () =>
          import('../../feature/files/files.routes').then(
            (m) => m.filesRoutes,
          ),
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('../../feature/patients/patients.routes').then(
            (m) => m.patientsRoutes,
          ),
      },
    ],
  },
];
